import React,{useState} from "react"
import "../style/nav.css"




function Nav (prop)
{



    return(
        <div className="nav">
            <div className="navBarContainer">
                <div className="name_box">
                  <h3  className="name">Hezi Rahmani</h3>
                </div>
             
                
                <nav >
                    <ul className="nav_list">
                        <li className="nav_item"><a className="nav_link" href="#landingPage"  >HOME</a> </li>
                        <li className="nav_item"><a className="nav_link" href="#skills" >TECHNOLOGY'S</a> </li>
                        {/* <li className="nav_item"><a className="nav_link" href="#" >ABOUT</a></li> */}
                        <li className="nav_item"><a className="nav_link" href="#projects" >PROJECTS</a> </li>
                    </ul>
                </nav>

            </div>
        
    
<div className="nav_space">
<a href="https://github.com/heziRahmani" target="blanck"> <img src="images\pngkey.com-github-icon-png-1787508.png"/></a>
    <a href="https://linkedin.com/in/hezi-rahmani-7a5a471b4" target="blanck"><img src="images\linkedin-logo.png"/></a>
    <a href="mailto:hezirahmani@gmail.com"><img src="images\Daco_4136204.png"/></a>
</div>


        </div>
    )
    
}

export default Nav




// tuggleClass=()=>{
//     if(this.state.isHamburger===false)
//     {
//         this.setState({isHamburger:true})
//     }
//     else if(this.state.isHamburger===true)
//     {
//         this.setState({isHamburger:false})

//     }
// }






//  button
//  className={this.state.isHamburger?"nav__tuggle hamburger_open ":"nav__tuggle "}
//  span
//  mburger hamburger_tuggle ":"hamburger"}
//  onClick={()=>this.setState({isvisable:false,isHamburger:false})}
// onClick={()=>this.setState({isvisable:false,isHamburger:false})}
// onClick={()=>this.setState({isvisable:!this.state.isvisable})}  
// onClick={this.tuggleClass} className={this.state.isHamburger?"ha
// onClick={()=>this.setState({isvisable:false,isHamburger:false})}
// onClick={()=>this.setState({isvisable:false,isHamburger:false})}
// nav className={this.state.isvisable?"nav_open":"nav"}